import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import NumberFormat from 'react-number-format'

import styles from './InputNumberFormat.module.scss'

export const InputNumberFormat = ({
  allowEmptyFormatting,
  allowNegative,
  className,
  decimalSeparator,
  decimalScale,
  defaultValue,
  format,
  error,
  handleIsAllowed,
  isDisabled = false,
  mask,
  onChange,
  onBlur,
  placeholder,
  size = 'regular',
  setInputRef,
  thousandSeparator,
  thousandsGroupStyle,
  value,
}) => (
  <NumberFormat
    allowEmptyFormatting={allowEmptyFormatting}
    allowNegative={allowNegative}
    className={classNames(styles.input, className, {
      [styles.regular]: size === 'regular',
      [styles.small]: size === 'small',
      [styles.error]: !!error,
    })}
    decimalSeparator={decimalSeparator}
    decimalScale={decimalScale}
    defaultValue={defaultValue}
    disabled={isDisabled}
    format={format}
    getInputRef={setInputRef}
    isAllowed={handleIsAllowed}
    isNumericString
    mask={mask}
    onBlur={onBlur}
    onValueChange={onChange}
    placeholder={placeholder}
    thousandSeparator={thousandSeparator}
    thousandsGroupStyle={thousandsGroupStyle}
    value={value}
  />
)

InputNumberFormat.propTypes = {
  allowEmptyFormatting: PropTypes.bool,
  allowNegative: PropTypes.bool,
  className: PropTypes.string,
  decimalSeparator: PropTypes.string,
  decimalScale: PropTypes.number,
  defaultValue: PropTypes.string,
  error: PropTypes.string,
  format: PropTypes.string,
  handleIsAllowed: PropTypes.func,
  isDisabled: PropTypes.bool,
  mask: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(['regular', 'small']),
  setInputRef: PropTypes.func,
  thousandSeparator: PropTypes.string,
  thousandsGroupStyle: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
